import "./FoodStats.css";

import {
  MdRestaurantMenu,
  MdCheckCircle,
  MdCancel,
  MdStar,
} from "react-icons/md";

function FoodStats({ foods = [] }) {
  const totalFoods = foods.length;

  const availableFoods = foods.filter(
    (food) => food.isAvailable
  ).length;

  const unavailableFoods = foods.filter(
    (food) => !food.isAvailable
  ).length;

  const todaysSpecial = foods.filter(
    (food) => food.availableToday
  ).length;

  const stats = [
    {
      title: "Total Foods",
      value: totalFoods,
      icon: <MdRestaurantMenu />,
      className: "total",
    },
    {
      title: "Available",
      value: availableFoods,
      icon: <MdCheckCircle />,
      className: "available",
    },
    {
      title: "Unavailable",
      value: unavailableFoods,
      icon: <MdCancel />,
      className: "unavailable",
    },
    {
      title: "Today's Special",
      value: todaysSpecial,
      icon: <MdStar />,
      className: "special",
    },
  ];

  return (
    <div className="food-stats">

      {stats.map((stat, index) => (
        <div
          key={index}
          className={`food-stat-card ${stat.className}`}
        >
          <div className="food-stat-icon">
            {stat.icon}
          </div>

          <div className="food-stat-content">
            <h4>{stat.title}</h4>
            <h2>{stat.value}</h2>
          </div>
        </div>
      ))}

    </div>
  );
}

export default FoodStats;